import React, { useEffect } from "react";
import EnumField from "../ui/EnumField";
import { KBD } from "../utils/Keybindings";
import { useTabs } from "../hooks/useTabs";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import { listen } from "../hooks/Listener";

export default function MorePrintOptions(props) {

    const { controller = "", route = "", callback = () => { } } = props




    const sort_options = [
        { label: "Sequential (as entered)", value: "S", key: KBD.S },
        { label: "None", value: "N", key: KBD.N },
        { label: "Title", value: "T", key: KBD.T },
        { label: "Class, Author", value: "A", key: KBD.A },
        { label: "Class, Title", value: "C", key: KBD.C },
        { label: "ISBN", value: "I", key: KBD.I },
        { label: "Customer PO", value: "P", key: KBD.P },
    ];

    const default_options = [
        { label: "Yes", value: "Y", key: KBD.Y },
        { label: "No", value: "N", key: KBD.N }
    ];

    const defaultTabs = [
        { key: "sort", value: "S", skip: false },
        { key: "default", value: "N", skip: false },
    ];

    const statuses = {
        sort : "[S]equential, [N]one, [T]itle, [A]Class - Author, [C]lass - Title, [I]SBN, Customer [P]O ",
        default : "[Y]es, [N]o",
    }


    const { tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs } = useTabs(defaultTabs, "sort");



      useEffect(() => {
    
            if (refs?.current?.[index]) {
                refs.current[index].focus();
            }
    
            const actions = [
                { key: KBD.ESCAPE, action: (e) => { callback(false) } },
                  { key: KBD.PAGE_DOWN, action: (e) => { callback(false) } },
                { key: KBD.ARROW_DOWN, action: (e) => { next() } },
                { key: KBD.ARROW_UP, action: (e) => { prev() } },
            ];
            const cleanup = listen(controller, route, actions, false, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.PAGE_UP, KBD.PAGE_DOWN, KBD.ALT_S, KBD.ALT_H, KBD.ESCAPE]);
            return cleanup;
        }, [index]);



    return (



        <div style={{ "width": "700px", "padding": "0px 10px" }}>


            <div className="shim" /><div className="shim" /><div className="shim" />

            <Space height={25} size={10}>
                <Label className={(index === "isbn") ? "selected" : ""} width={80}>Sort By</Label>
                <EnumField allow_empty={false} className={(index !== "isbn") ? "dim" : ""} {...editProps("sort")} options={sort_options} />
            </Space>
            <div className="shim" />
            <Space height={25} size={10}>
                <Label className={(index === "isbn") ? "selected" : ""} width={80}>Default?</Label>
                <EnumField allow_empty={false} className={(index !== "isbn") ? "dim" : ""} {...editProps("default")} options={default_options} />
            </Space>

            <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />

            <div style={{ "backgroundColor": "var(--console-bg)", "margin": "-10px -10px", "borderTop": "2px solid var(--border-secondary)", "padding": "10px", "borderBottomLeftRadius": "5px", "borderBottomRightRadius": "5px" }}>
                <Status><InfoIcon /> {statuses[index]}</Status>
            </div>

        </div>

    )
}
